import { Component, HostListener, Inject, OnInit } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface DialogData {
  icon:string,
  textIcon:string,
  title:string,
  text:string,
  textExtra:string,
  textLink:string,
  linkAdress:string
}

@Component({
  selector: 'app-model-modal-contact',
  templateUrl: './model-modal-contact.component.html',
  styleUrls: ['./model-modal-contact.component.scss']
})
export class ModelModalContactComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModelModalContactComponent>,  @Inject(MAT_DIALOG_DATA) public data: DialogData) { }
  ngOnInit(): void {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  @HostListener("keydown.esc")
  public onEsc() {
    this.dialogRef.close(false);
  }




}
